import convenio from "./convenio"
import particular from "./particular"

const page = {
    convenio,
    particular,
}

export default page